// Admin-only: Google Sheet vs database row counts per month (flags rows the sync missed).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function CoverageCard({ coverage, coverageError, coverageLoading, coverageOpen, loadCoverage, me, setCoverageOpen }) {
  return (
    <>
      {me && me.isAdmin && (coverage || coverageLoading || coverageError) && (() => {
        const warn = coverage && coverage.hasWarnings;
        const bg = coverageError ? '#fef2f2' : warn ? '#fef3c7' : '#f0fdf4';
        const fg = coverageError ? '#991b1b' : warn ? '#92400e' : '#166534';
        return (
          <div className="card" style={{ padding: '0.6rem 1rem', marginBottom: '0.75rem', background: bg, color: fg, fontSize: '0.9em' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.6rem' }}>
              <strong>Sheet ↔ DB coverage (from {coverage ? coverage.fromMonth : '2026-05'}):</strong>
              {coverageLoading && <span>checking…</span>}
              {coverageError && <span>error — {coverageError}</span>}
              {coverage && !coverage.hasWarnings && (
                <span>✓ all months match — {coverage.totalSheet.toLocaleString()} sheet rows = {coverage.totalDb.toLocaleString()} DB rows</span>
              )}
              {coverage && coverage.hasWarnings && (
                <span>
                  <strong>⚠ {coverage.monthsWithIssuesCount} month{coverage.monthsWithIssuesCount === 1 ? '' : 's'}</strong> with discrepancy.
                  Sheet has <strong>{coverage.totalSheet.toLocaleString()}</strong>, DB has <strong>{coverage.totalDb.toLocaleString()}</strong>
                  {' '}(diff <strong>{coverage.totalDiff > 0 ? '+' : ''}{coverage.totalDiff}</strong>).
                </span>
              )}
              <span style={{ marginLeft: 'auto', display: 'flex', gap: '0.4rem' }}>
                {coverage && <button className="link" onClick={() => setCoverageOpen(!coverageOpen)}>{coverageOpen ? 'hide details' : 'details'}</button>}
                <button className="link" disabled={coverageLoading} onClick={loadCoverage}>recheck</button>
              </span>
            </div>
            {coverage && coverageOpen && (
              <table style={{ marginTop: '0.5rem', fontSize: '0.85em', borderCollapse: 'collapse' }}>
                <thead><tr style={{ textAlign: 'left' }}>
                  <th style={{ padding: '2px 12px 2px 0' }}>Month</th>
                  <th style={{ padding: '2px 12px 2px 0', textAlign: 'right' }}>Sheet</th>
                  <th style={{ padding: '2px 12px 2px 0', textAlign: 'right' }}>DB</th>
                  <th style={{ padding: '2px 12px 2px 0', textAlign: 'right' }}>Diff</th>
                  <th style={{ padding: '2px 0' }}>Status</th>
                </tr></thead>
                <tbody>
                  {coverage.months.map(m => (
                    <tr key={m.month} style={{ background: m.status === 'ok' ? 'transparent' : 'rgba(220,38,38,0.06)' }}>
                      <td style={{ padding: '2px 12px 2px 0' }}>{m.month}</td>
                      <td style={{ padding: '2px 12px 2px 0', textAlign: 'right' }}>{m.sheetCount.toLocaleString()}</td>
                      <td style={{ padding: '2px 12px 2px 0', textAlign: 'right' }}>{m.dbCount.toLocaleString()}</td>
                      <td style={{ padding: '2px 12px 2px 0', textAlign: 'right', fontWeight: m.status === 'ok' ? 'normal' : 'bold' }}>{m.diff > 0 ? '+' : ''}{m.diff}</td>
                      <td style={{ padding: '2px 0' }}>{m.status === 'ok' ? 'ok' : m.status === 'missing_in_db' ? 'missing in DB' : 'extra in DB'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        );
      })()}
    </>
  );
}
